import { createContext, createRef, useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import uuid from './uuid';
import { jsx as _jsx } from "react/jsx-runtime";
const ReactNodeViewContext = /*#__PURE__*/createContext({
  node: undefined,
  view: undefined,
  getPos: undefined,
  decorations: undefined
});
class ReactNodeView {
  constructor(node, view, getPos, decorations, component, updateFn) {
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.decorations = decorations;
    this.component = component;
    this.componentRef = /*#__PURE__*/createRef();
    this.updateFn = updateFn;
    this.dom = document.createElement('div');
  }
  init() {
    this.dom = document.createElement('div');
    this.dom.classList.add('ProseMirror__dom');
    if (!this.node.isLeaf) {
      this.contentDOM = document.createElement('div');
      this.contentDOM.classList.add('ProseMirror__contentDOM');
      this.dom.appendChild(this.contentDOM);
    }
    return {
      nodeView: this,
      portal: this.renderPortal(this.dom)
    };
  }
  renderPortal(container) {
    const Component = props => {
      const componentRef = useRef(null);
      useEffect(() => {
        const componentDOM = componentRef.current;
        if (componentDOM != null && this.contentDOM != null) {
          if (!this.node.isLeaf && componentDOM.firstChild) {
            componentDOM.firstChild.appendChild(this.contentDOM);
          }
        }
      }, [componentRef]);
      return /*#__PURE__*/_jsx("div", {
        ref: componentRef,
        className: "ProseMirror__reactComponent",
        children: /*#__PURE__*/_jsx(ReactNodeViewContext.Provider, {
          value: {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            decorations: this.decorations
          },
          children: /*#__PURE__*/_jsx(this.component, Object.assign({}, props))
        })
      });
    };
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx(Component, {}), container, uuid());
  }
  update(node, decorations) {
    if (this.updateFn) {
      return this.updateFn({
        previousNode: this.node,
        node,
        decorations
      });
    }
    return false;
  }
  destroy() {
    this.dom = document.createElement('div');
    this.contentDOM = undefined;
  }
}
export const createReactNodeView = ({
  node,
  view,
  getPos,
  decorations,
  component,
  onCreatePortal,
  updateFn
}) => {
  const reactNodeView = new ReactNodeView(node, view, getPos, decorations, component, updateFn);
  const {
    nodeView,
    portal
  } = reactNodeView.init();
  setTimeout(() => onCreatePortal(portal), 0);
  return nodeView;
};
export const useReactNodeView = () => useContext(ReactNodeViewContext);
export default ReactNodeView;